import React, { FC } from 'react';

import { Avatar, Box, HStack } from '@chakra-ui/react';

import { CustomTooltip } from 'components/DataDisplay';
import {
  getApproverAvatarColor,
  getApproverInitials,
} from 'containers/Jit/JitRequests/Components/utils';

interface Props {
  emails: string[];
  max?: number;
}

// Jira-style approver avatars: each circle overlaps the previous one, with a
// white ring to separate them. Extra approvers collapse into a "+N" circle.
export const OverlappingApprovers: FC<Props> = props => {
  const { emails, max = 5 } = props;
  if (!emails.length) return <Box>-</Box>;

  const visible = emails.length > max ? emails.slice(0, max - 1) : emails;
  const hidden = emails.slice(visible.length);
  const ringStyles = {
    size: 'sm',
    color: 'white',
    border: '2px solid white',
    ml: -2,
  };

  return (
    <HStack spacing={0} pl={2}>
      {visible.map((email, index) => (
        <CustomTooltip key={email} label={email}>
          <Avatar
            {...ringStyles}
            name={getApproverInitials(email)}
            // Keep both initials ("BV"); Avatar would otherwise reduce a
            // single word to its first letter.
            getInitials={name => name}
            bg={getApproverAvatarColor(email)}
            aria-label={email}
            // Later circles sit on top so each one overlaps the previous.
            zIndex={index}
          />
        </CustomTooltip>
      ))}
      {hidden.length > 0 && (
        <CustomTooltip label={hidden.join(', ')}>
          <Avatar
            {...ringStyles}
            name={`+ ${hidden.length}`}
            getInitials={name => name}
            bg="gray.300"
            fontSize="xs"
            zIndex={visible.length}
          />
        </CustomTooltip>
      )}
    </HStack>
  );
};
